<template>
  <form v-if="value">
    <string-form-field
      label="Etichetta"
      :value="value.label"
      :disabled="disabled"
      :error="findError('label')"
      @input="propertyChanged('label', $event)"
    />
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
